import { AuditSubRowLine } from '../dashboards/workshops/detail/AuditSubRowLine';

import HistoryChangeLine from './HistoryChangeLine';
import HistoryHeadcountLine from './HistoryHeadcountLine';
import type { HistoryChangeView as Change } from './private-event-history-rows';

export default function HistoryChangeView({ change }: { change: Change }) {
  if (change.kind === 'headcount') return <HistoryHeadcountLine {...change} />;
  if (change.kind === 'text') return <HistoryChangeLine {...change} />;
  return (
    <>
      {change.subRows.map((row) => (
        <AuditSubRowLine key={row.key} row={row} />
      ))}
    </>
  );
}
